import { fetchApi, trackUserEvent } from '@vend/utilities'
import { SwiperError, SwiperErrorResponse } from './lspay.types'

export interface CreateCnpPmofSessionOptions {
  amount: number
  customerId?: string
  registerSalePaymentId: string
  registerId: string
  retailerPaymentTypeId: string
  metadata?: Record<string, string>
}

export interface CnpPmofSessionResponse {
  session: string
  paymentId: string
}

export const createCnpPmofSession = async ({
  amount,
  customerId,
  registerId,
  registerSalePaymentId,
  retailerPaymentTypeId,
  metadata = {},
}: CreateCnpPmofSessionOptions): Promise<CnpPmofSessionResponse> => {
  const body: Record<string, any> = {
    amount,
    register_id: registerId,
    register_sale_payment_id: registerSalePaymentId,
    retailer_payment_type_id: retailerPaymentTypeId,
    metadata,
  }
  if (customerId) {
    body.customer_id = customerId
  }

  trackUserEvent('webregister', 'LSPay Create CNP PMOF Session Request', {
    amount,
    registerId,
    registerSalePaymentId,
    retailerPaymentTypeId,
    hasCustomerId: !!customerId,
  })

  const response = await fetchApi(
    `/api/2.0/lspay/payment-methods/moto-session`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    }
  )

  if (!response.ok) {
    const swiperError: SwiperErrorResponse = await response.json()

    throw new SwiperError(
      swiperError.error,
      swiperError.code,
      swiperError.fields
    )
  }
  const data = await response.json()
  return { session: data.session, paymentId: data.payment_id }
}
